function installmentsMobile(width) {
    // console.log('good');j
    if (width <= 767) {
        $('.installments__wrap').append($('.installments .installments__lamp'));
    } else {
        $('.installments__left').append($('.installments__wrap .installments__lamp'));
    }

}






$(window).resize(function () {
    if ($('.installments').length >= 0)
        installmentsMobile(window.innerWidth);
});

if ($('.installments').length >= 0)
    installmentsMobile(window.innerWidth);